import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ToastService } from '@libs/src/toast/toast.service';

import capitalize from 'lodash-es/capitalize';
import compact from 'lodash-es/compact';
import filter from 'lodash-es/filter';
import find from 'lodash-es/find';
import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';
import isEqual from 'lodash-es/isEqual';
import map from 'lodash-es/map';
import upperCase from 'lodash-es/upperCase';

@Component({
  selector: 'app-dialog-sessions-settings',
  templateUrl: './dialog-sessions-settings.component.html',
  styleUrls: ['./dialog-sessions-settings.component.scss'],
})
export class DialogSessionsSettingsComponent implements OnInit {
  sessions: any[];
  tableColumns: any[];

  constructor(
    private dialogRef: MatDialogRef<DialogSessionsSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.tableColumns = this.data.tenant.enabled_features.profile
      ? [
          {
            width: '150px',
            label: 'Location',
          },
          {
            width: '150px',
            label: 'Last Accessed',
          },
          {
            width: '350px',
            label: 'Device Details',
          },
          {
            width: '100px',
          },
        ]
      : [
          {
            width: '225px',
            label: 'Location',
          },
          {
            width: '0px',
          },
          {
            width: '425px',
            label: 'Device Details',
          },
          {
            width: '100px',
          },
        ];
    this.sessions = map(get(this.data, 'sessions'), (session: any) => ({
      ...session,
      isLoading: false,
    }));
  }

  deleteSessions(sessionId: string): void {
    const sessionToDelete = find(this.sessions as any, { _id: sessionId });
    if (!sessionToDelete) {
      return;
    }
    sessionToDelete.isLoading = true;
    this.data.deleteSession(sessionId).subscribe(
      () => {
        this.sessions = filter(
          this.sessions,
          (session: any) => !isEqual(session._id, sessionId),
        );
        return this.toast.showSuccess('Successfully logged out!');
      },
      ({ error: { message } }: any) => this.toast.showError(message),
    );
  }

  parseSessionLocation(session: any): string {
    const sessionLocation = compact([
      capitalize(get(session, 'city', '')),
      upperCase(get(session, 'region', '')),
      upperCase(get(session, 'country', '')),
    ]);
    if (isEmpty(sessionLocation)) {
      sessionLocation.push(
        $localize`:@@settingsView.sessionsDialog.locationUnknown:Unknown Location`,
      );
    }
    return sessionLocation.join(', ');
  }

  close(): void {
    this.dialogRef.close();
  }
}
